import OrganisationHospitalDTO from '@src/adapters/dto/hospital/OrganisationHospitalDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  pageSize: number;
  currentPage: number;
  searchText: string;
  regionCode: string;
  isActive: boolean;
}

interface Result {
  records: OrganisationHospitalDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/hospitals',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSearchHospitalsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSearchHospitalsLazy;
